import React, { useEffect, useRef } from 'react';
import { Box, Button, css, Flex, styled, Text } from '@goodrx/matisse-react';
import { trackLink } from '@goodrx/x-core';
import { mediaMaxWidth } from '../../../../utils';
const StyledTitle = styled.h4`
  && {
    text-align: center;
    margin: 0;
    font-weight: 800;
    font-size: 1.125rem;
  }

  ${mediaMaxWidth({
  sm: css`
      && {
        font-size: 1rem;
        text-align: left;
        margin-right: 2.5rem;
      }
    `
})}
`;
const StyledSubtitle = styled(Text)`
  & {
    font-size: 16px;
    margin: 8px 0 16px;
    font-weight: normal;
    line-height: 24px;
    flex: 1 1 0%;
  }
  ${mediaMaxWidth({
  sm: css`
      & {
        font-size: 14px;
        min-height: 35px;
        line-height: 20px;
        margin-bottom: 12px;
      }
    `
})}
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: 1 1 auto;
    width: 100%;
  }
`;
const StyledPrice = styled.div`
  & {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    background: #f8f8f9;
    color: #484d55;
    border-radius: 28px;
    display: flex;
    justify-content: center;
    margin-top: 11px;
    font-size: 14px;
    font-weight: 500;
  }
  ${mediaMaxWidth({
  sm: css`
      & {
        margin-top: 14px;
      }
    `
})}
`;
const StyledFlex = styled(Flex)`
  & {
    max-width: 400px;
    position: relative;
    border-top: 1px solid #e8e9ea;
    align-items: center;
    flex-direction: column;
    text-decoration: none;
    color: inherit;
    padding: 0 16px;
    display: flex;
    justify-content: flex-start;
    height: 100%;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: 1 1 auto;
  }
  ${({
  theme
}) => css`
    @media (min-width: ${theme.breakpoints.md}) {
      &:hover {
        button {
          background-color: #0958f3;
          color: #ffffff;
        }
      }
    }
  `}

  ${mediaMaxWidth({
  sm: css`
      & {
        flex-direction: row;
        align-items: flex-start;
        max-width: 100%;
        padding: 12px 0 0;
      }
    `
})}
`;
const InnerContent = styled(Flex)`
  & {
    align-items: center;
    flex-direction: column;
    flex: 1 1 0%;
  }
  & > span {
    text-align: center;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: 1 1 auto;
    width: 100%;
  }

  ${mediaMaxWidth({
  sm: css`
      & {
        margin-left: 16px;
        align-items: flex-start;
      }
      & > span {
        text-align: left;
      }
    `
})}
`;
const Image = styled(Box)`
  & {
    margin: 19px 0 8px;
  }

  & > img {
    width: 48px;
    height: 48px;
  }

  ${mediaMaxWidth({
  sm: css`
      & {
        margin: 0;
      }

      & > img {
        width: 32px;
        height: 32px;
      }
    `
})}
`;
export const HeyDoctorService = ({
  className,
  displayTitle,
  subtitle,
  image,
  price,
  contentCollection
}) => {
  const link = contentCollection === null || contentCollection === void 0 ? void 0 : contentCollection.items[0];
  const linkRef = useRef(null);
  useEffect(() => {
    if (!linkRef.current) {
      return;
    }

    trackLink(linkRef.current, 'Service Clicked', {
      name: displayTitle,
      location: 'featured'
    });
  }, [displayTitle]);
  return /*#__PURE__*/React.createElement(StyledFlex, {
    as: "a",
    className: className,
    href: link !== null && link !== void 0 && link.url ? link.url : '',
    ref: linkRef
  }, /*#__PURE__*/React.createElement(StyledPrice, null, "$", price), /*#__PURE__*/React.createElement(Image, null, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: image !== null && image !== void 0 && image.url ? image.url : ''
  })), /*#__PURE__*/React.createElement(InnerContent, null, /*#__PURE__*/React.createElement(StyledTitle, null, displayTitle), /*#__PURE__*/React.createElement(StyledSubtitle, null, subtitle), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "secondary"
  }, link === null || link === void 0 ? void 0 : link.displayTitle)));
};